import { all, put, takeEvery } from "redux-saga/effects";
import URLs from "../../../constants/urls";
import { apiPython as api } from "../../../service/api";
import { SEND_USER_EMAIL } from "../../actions/ManageEmail/ManageEmailType";
import { setManageEmailFailureAction, SendEmail } from "../../features/ManageEmail/ManageEmailSlice";

export function* setManageEmailSaga({ payload: body }) {
    console.log('body - email', body);
    try {
      const response = yield api.post(URLs.SEND_EMAIL, body);
      console.log('response - email', response);
      yield put(SendEmail(response.data));
    } catch (error) {
        console.log('error - email', error)
      yield put(setManageEmailFailureAction
        (error?.response?.data?.message ? error?.response?.data?.message : 'Could not save'));
    }
  }

  export function* watchManageEmail() {
    yield takeEvery(SEND_USER_EMAIL, setManageEmailSaga);
  }

  export default function* manageEmailSaga() {
    yield all([watchManageEmail()]);
  }